import HighContrastToggle from '@/components/HighContrastToggle'
import LogoutButton from '@/components/LogoutButton'
import { useCanvasChromePosition } from '@/hooks/useCanvasChromePosition'
import styles from './PageChrome.module.css'

/** Fixed top-right controls shown on every page. */
export default function PageChrome() {
  const { isCanvas, positionStyle } = useCanvasChromePosition()

  return (
    <div
      className={`${styles.chrome} ${isCanvas ? styles.chromeCanvas : ''}`}
      style={isCanvas ? positionStyle : undefined}
      role="toolbar"
      aria-label="Page controls"
    >
      <HighContrastToggle />
      <LogoutButton />
    </div>
  )
}
